export const FETCH_PROMOCIONES_REQUEST = "FETCH_PROMOCIONES_REQUEST";
export const FETCH_PROMOCIONES_SUCCESS = "FETCH_PROMOCIONES_SUCCESS";
export const FETCH_PROMOCIONES_FAILURE = "FETCH_PROMOCIONES_FAILURE";
